export default "__VITE_PUBLIC_ASSET__4d900b25__"